import { endPoints, requestType } from "../lib/variable";
import Api from "./index";

const getAllPromo = (id) => {
  return Api(endPoints.fetchPromo, requestType.GET);
};
const createPromo = (payload) => {
  return Api(endPoints.createPromo, payload, requestType.POST);
};
const updatePromo = (payload, id) => {
  return Api(`${endPoints.updatePromo}/${id}`, payload, requestType.POST);
};
const deletePromo = (id) => {
  return Api(`${endPoints.deletePromo}/${id}`, null, requestType.DELETE);
};
export { getAllPromo, createPromo, updatePromo, deletePromo };
